import { getLogger } from './utils/logger-context';
import { resolveComponentScope } from './utils/resolveComponentScope';

// select2 fires jQuery-only events; native listeners (htmx, addEventListener)
// never hear them. Dispatch a native change so all consumers stay in sync.
const dispatchNativeChange = (el) => {
    el[0]?.dispatchEvent(new Event('change', { bubbles: true }));
};

const initSelect2 = (elem) => {
    let select2Params;

    $(elem).each(function () {
        const dataWidget = $(this).attr('data-widget');
        const isTags = $(this).data('tags') || false;
        const isMultiple = $(this).prop('multiple');
        const isDeselect = dataWidget === 'select2-deselect';
        const isOptGroup = $(this).children('optgroup').length !== 0;
        const dataDisableSorting = $(this).attr('data-disable-sorting');
        const firstOption = $(this).children('option:first-child');
        const deselectPlaceholder =
            firstOption.val() === '' &&
            firstOption.text() !== '' &&
            !firstOption.text().includes('---')
                ? { id: -1, text: 'Select item...' }
                : 'Select item...';
        const formatSelect2Text = (state) => {
            if ($(state.element).data('icon')) {
                return $(
                    `<span><span class="tako-icon"><i class="far ${$(
                        state.element,
                    ).data('icon')}"></i></span>
                        ${state.text}
                    </span>`,
                );
            } else {
                return state.text;
            }
        };
        // use custom matcher for searching options
        const matchCustom = (params, data) => {
            // If there are no search terms, return all of the data
            if ($.trim(params.term) === '') {
                return data;
            }

            const isMatchingOption = (element) => {
                if (
                    element.text
                        .toUpperCase()
                        .indexOf(params.term.toUpperCase()) > -1
                ) {
                    return true;
                } else {
                    return false;
                }
            };

            if (isOptGroup) {
                // skip if there is no 'children' property
                if (typeof data.children === 'undefined') {
                    return null;
                }

                // `data.children` contains the actual options that we are matching against
                const filteredChildren = [];
                $(data.children).each(function () {
                    if (isMatchingOption(this)) {
                        filteredChildren.push(this);
                    }
                });

                // if we matched any of the group's children, then set the matched children on the group
                // and return the group object
                if (filteredChildren.length) {
                    const modifiedData = $.extend({}, data, true);
                    modifiedData.children = filteredChildren;

                    // return modified data
                    return modifiedData;
                }
            } else {
                // skip if there is no 'text' property
                if (typeof data.text === 'undefined') {
                    return null;
                }

                if (isMatchingOption(data)) {
                    const modifiedData = $.extend({}, data, true);

                    // return modified data
                    return modifiedData;
                }
            }

            // return `null` if the term should not be displayed
            return null;
        };
        // Sort options in the dropdown alphabetically
        const sortOptions = (data) => {
            if (dataDisableSorting === 'true' || dataDisableSorting === '') {
                return data;
            }
            return data.sort((a, b) => a.text.localeCompare(b.text));
        };
        const select2DefaultParams = {
            default: {
                placeholder: 'Select item...',
                templateSelection: formatSelect2Text,
                templateResult: formatSelect2Text,
                width: '100%',
                matcher: matchCustom,
            },
            deselect: {
                placeholder: deselectPlaceholder,
                templateSelection: formatSelect2Text,
                templateResult: formatSelect2Text,
                width: '100%',
                allowClear: true,
                matcher: matchCustom,
            },
            multiple: {
                placeholder: isTags ? 'Define items...' : 'Select items...',
                width: '100%',
                closeOnSelect: false,
                allowClear: true,
                matcher: matchCustom,
                sorter: sortOptions,
                tags: isTags,
            },
        };

        if (isMultiple) {
            select2Params = select2DefaultParams.multiple;
        } else if (isDeselect) {
            select2Params = select2DefaultParams.deselect;
        } else {
            select2Params = select2DefaultParams.default;
        }

        $(this).select2(select2Params);

        if (isMultiple) {
            addSelect2MultipleEventListeners($(this));
        } else {
            addSelect2EventListeners($(this));
        }
    });
};

// add event listeners
const addSelect2EventListeners = (el) => {
    const searchInputClass = '.select2-search__field';
    const selectResult = el.next().find('.select2-selection__rendered');
    const dataWidget = el.attr('data-widget');
    const clearButtton =
        '<div class="select2-selection__clear-new"><button type="button"></button></div>';
    let selectValue = el.val();

    // replace default clear button to fix keyboard accessibility issues
    if (dataWidget === 'select2-deselect') {
        el.next().find('.select2-selection__clear').remove();
        el.next().find('.selection').after(clearButtton);
    }

    el.on('select2:open', () => {
        const searchField = $('.select2-search--dropdown').find(
            searchInputClass,
        );
        /**
         * if select is part of a modal
         * - add an attribute to change z-index
         */
        if (el.parent('.tako-modal__dialog')) {
            $('.select2-dropdown').attr('data-modal-content', true);
        }

        searchField[0].focus();
        searchField.keydown((e) => {
            // remove clear button while typing in search field
            if (
                e.keyCode != 40 &&
                e.keyCode != 38 &&
                e.keyCode != 13 &&
                e.keyCode != 9
            ) {
                selectResult.hide();
                el.next().find('.select2-selection__clear-new button').hide();
            }

            // prevent selection when pressing tab
            if (e.keyCode == 9 && selectValue !== el.val()) {
                el.val(selectValue);
                dispatchNativeChange(el);
                el.next().find('.select2-selection__clear').remove();
                if (!el.val() || el.val() === '') {
                    el.next()
                        .find('.select2-selection__clear-new button')
                        .hide();
                }
            }

            const noOptionMessage = $(
                '.select2-results__option.select2-results__message',
            );
            if (e.keyCode == 9 && noOptionMessage.length) {
                el.select2('close');
            }
        });
    });
    el.on('select2:select', () => {
        el.next().find('.select2-selection__clear').remove();
        setTimeout(() => {
            selectValue = el.val();
        }, 500);
        if (el.val()) {
            el.next().find('.select2-selection__clear-new button').show();
        } else {
            el.next().find('.select2-selection__clear-new button').hide();
        }
        dispatchNativeChange(el);
    });
    el.on('select2:unselect', () => {
        selectValue = el.val();
        dispatchNativeChange(el);
    });
    el.on('select2:close', () => {
        selectResult.show();
        if (el.val()) {
            el.next().find('.select2-selection__clear-new button').show();
        }
    });
    el.next()
        .find('.select2-selection__clear-new button')
        .click((e) => {
            el.val('');
            dispatchNativeChange(el);
            selectValue = el.val();
            $(e.target).hide();
            el.select2('open');
            el.next().find('.select2-selection__clear').remove();
        });

    if (!el.val() || el.val() === '') {
        el.next().find('.select2-selection__clear-new button').hide();
    }
};

const addSelect2MultipleEventListeners = (el) => {
    const searchField = el.next().find('.select2-search__field');

    // remove optgroup if there's no options in it
    const removeEmptyOptGroup = () => {
        const optGroup = $('.select2-dropdown').find(
            '.select2-results__option--group',
        );

        if (optGroup.length !== 0) {
            optGroup.each(function () {
                if (
                    $(this).find(
                        '.select2-results__option:not(".select2-results__option--selected")',
                    ).length === 0
                ) {
                    $(this).detach();
                }
            });
        }
    };

    // add message when no option left in the dropdown
    const addNoOptionsMessage = () => {
        const message =
            '<li class="select2-results__option select2-results__message">No options</li>';

        if (
            $(
                '.select2-results__option:not(".select2-results__option--selected")',
            ).length === 0
        ) {
            $('.select2-dropdown')
                .find('.select2-results__options')
                .append(message);
        }
    };

    let selectValue = el.val();

    el.on('select2:open', () => {
        $('.select2-dropdown').addClass('select2-dropdown--multiple');

        /**
         * if select is part of a modal
         * - add an attribute to change z-index
         */
        if (el.parent('.tako-modal__dialog')) {
            $('.select2-dropdown').attr('data-modal-content', true);
        }

        searchField.keydown((e) => {
            // prevent selection when pressing tab
            if (e.keyCode == 9 && selectValue !== el.val()) {
                el.select2('close');
                el.val(selectValue);
                dispatchNativeChange(el);
            }
        });

        searchField.keyup(() => {
            removeEmptyOptGroup();
        });

        $('.select2-dropdown').hide();

        setTimeout(() => {
            removeEmptyOptGroup();
            addNoOptionsMessage();
            $('.select2-dropdown').show();
        }, 100);
    });
    el.on('select2:close', () => {
        searchField[0].blur();
    });
    el.on('select2:select', (evt) => {
        searchField[0].focus();

        // remove selected options from dropdown
        const element = evt.params.data.element;
        const elementParent = $(element).parent();

        $(element).detach();
        elementParent.append($(element));
        dispatchNativeChange(el);

        removeEmptyOptGroup();
        addNoOptionsMessage();

        selectValue = el.val();

        // clear search field after selecting an option
        searchField.val('').trigger('input');
    });
    el.on('select2:unselect', () => {
        selectValue = el.val();
        dispatchNativeChange(el);
    });
};

const COMPONENT_NAME = 'Select';

// init select2 widget for all select fields with data-widget select2 or select2-deselect
export const init = (unresolvedScope) => {
    const logger = getLogger();
    const scope = resolveComponentScope(unresolvedScope);
    const defaultLoggerArgs = {
        componentName: COMPONENT_NAME,
        scope,
    };
    logger.debug(`Initialising ${COMPONENT_NAME} component.`, {
        scope: document,
    });

    const selectDefault = $('select[data-widget="select2"]');
    if (selectDefault.length !== 0) {
        selectDefault.each(function () {
            try {
                if (!$(this).hasClass('select2-hidden-accessible')) {
                    initSelect2($(this));
                }
            } catch (error) {
                logger.error(error, {
                    ...defaultLoggerArgs,
                    element: this,
                });
            }
        });
    }

    const selectDeselect = $('select[data-widget="select2-deselect"]');
    if (selectDeselect.length !== 0) {
        selectDeselect.each(function () {
            try {
                if (!$(this).hasClass('select2-hidden-accessible')) {
                    initSelect2($(this));
                }
            } catch (error) {
                logger.error(error, {
                    ...defaultLoggerArgs,
                    element: this,
                });
            }
        });
    }
};
